import React from 'react';
import './autoketing-modal.scss';
import { classNames } from '../../../utilities';
import { ReactComponent as Close } from '../../../assets/images/icons/close.svg';

export default function AutoketingModal({
  children,
  open,
  maxWidth = 520, // max width
  onClose,
  closeIcon = true, // show button icon
  width100 = true // width 100%
}) {
  const className = classNames('Autoketing-Modal', open && 'Autoketing-Modal--active');
  const classNameInner = classNames('Autoketing-Modal__Inner', width100 && 'w-100');
  return (
    <>
      <div className={className} style={{ '--ak-modal-max-width': `${maxWidth}px` }} onClick={onClose}>
        <div className={classNameInner} onClick={event => event.stopPropagation()}>
          {closeIcon && (
            <div className='Autoketing-Modal__Close' onClick={onClose}>
              <Close />
            </div>
          )}
          {children}
        </div>
      </div>
      {open && <div className='Polaris-Backdrop' />}
    </>
  );
}
